export class mdlOTPReq{
    public RegNo: number;
    public MobileNo: string;
    public EmailId: string;
    public Lng: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlOTPReq.ts